// extracted by mini-css-extract-plugin
module.exports = {"majorQuotaText":"index_majorQuotaText_2kULb","middleQuotaText":"index_middleQuotaText_qAf_g"};